module.exports = __webpack_public_path__ + "e849748a22ab45f0052876d59d0b3300.woff2";